module.exports = __webpack_public_path__ + "static/img/qrcode.70b1da42.png";